import React, { Suspense, lazy, useContext } from "react"
import { NastavitveContext } from "../../context/Nastavitev/NastavitveContext";

interface ExtCodeComponentLoaderArgs {
    baseComponentPath: string
}

const ExtCodeComponentLoader = ({ baseComponentPath }: ExtCodeComponentLoaderArgs) => {
    const nastavitve = useContext(NastavitveContext);

    const ExtCodeComponent = lazy(()=> import(`../../${baseComponentPath}-${nastavitve?.ExtCode}`)
        //.catch(() => import(`../../${baseComponentPath}`)));
        // alternativno lahko tudi
        .catch(() => import(`../../${baseComponentPath}-default`)));

    return (
       <>
            <Suspense fallback={<div>loading...</div>}>
                <ExtCodeComponent />
            </Suspense> 
        </>
    )
}

export default ExtCodeComponentLoader